// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wel-ui/components/VerticalSpacing/index.css
// module id = 159
// module chunks = 0